import { useEffect, useState } from "react";
import { useSearchParams, useNavigate, Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import api, { formatApiErrorDetail } from "@/lib/api";
import { UsersFour, CheckCircle, XCircle, SpinnerGap } from "@phosphor-icons/react";
import { Button } from "@/components/ui/button";

export default function TeamAccept() {
  const [params] = useSearchParams();
  const token = params.get("token");
  const { user, ready } = useAuth();
  const nav = useNavigate();
  const [state, setState] = useState({ status: "working", msg: "", inst: null });

  useEffect(() => {
    if (!ready) return;
    if (!token) { setState({ status: "error", msg: "This invitation link is invalid." }); return; }
    if (!user) return;
    api.post("/institutions/team/accept", { token })
      .then((r) => setState({ status: "ok", inst: r.data }))
      .catch((e) => setState({ status: "error", msg: formatApiErrorDetail(e.response?.data?.detail) }));
  }, [token, user, ready]);

  if (ready && !user) {
    return (
      <div className="mx-auto grid max-w-md place-items-center px-5 py-24 text-center" data-testid="team-accept-signin">
        <UsersFour size={40} weight="duotone" className="text-secondary" />
        <h1 className="mt-4 font-heading text-2xl font-light">You've been invited to a team</h1>
        <p className="mt-2 text-sm text-muted-foreground">Sign in or create your account with the invited email to accept and start co-managing the page.</p>
        <div className="mt-6 flex gap-3">
          <Link to={`/login?next=${encodeURIComponent(`/team/accept?token=${token || ""}`)}`}><Button className="rounded-full">Sign in</Button></Link>
          <Link to="/register"><Button variant="outline" className="rounded-full">Create account</Button></Link>
        </div>
      </div>
    );
  }

  return (
    <div className="mx-auto grid max-w-md place-items-center px-5 py-24 text-center" data-testid="team-accept-page">
      {state.status === "working" && <><SpinnerGap size={40} className="animate-spin text-secondary" /><p className="mt-4 text-muted-foreground">Accepting your invitation…</p></>}
      {state.status === "ok" && (
        <>
          <CheckCircle size={44} weight="fill" className="text-secondary" />
          <h1 className="mt-4 font-heading text-2xl font-light">You're on the team!</h1>
          <p className="mt-2 text-sm text-muted-foreground">You can now help manage <strong>{state.inst?.name}</strong>.</p>
          <Button className="mt-6 rounded-full" onClick={() => nav(`/institutions/${state.inst.institution_id}`)} data-testid="team-accept-goto">Go to the page</Button>
        </>
      )}
      {state.status === "error" && (
        <>
          <XCircle size={44} weight="fill" className="text-destructive" />
          <h1 className="mt-4 font-heading text-2xl font-light">Couldn't accept invitation</h1>
          <p className="mt-2 text-sm text-muted-foreground">{state.msg}</p>
          <Link to="/dashboard"><Button variant="outline" className="mt-6 rounded-full">Back to dashboard</Button></Link>
        </>
      )}
    </div>
  );
}
